export default __webpack_public_path__ + "e1fdf4994baf8640b183e76694d53390.png";